import type { Peer } from "@circle-react/types/Live/Peer";
import { useHMSPeerSignal } from "../hms";
import { useLivekitPeerSignal } from "../livekit";
import type { ProviderPeerSignal } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderPeerSignal = (peer: Peer): ProviderPeerSignal =>
  useProviderHook({
    hms: useHMSPeerSignal,
    livekit: useLivekitPeerSignal,
  })(peer);
